export const track = (event, attrs = {}) => window?.dataLayer?.push({ event, ...attrs })
